<template>
  <NavBar :breadcrumbdata="breadcrumbsinfo" breadcrumbtheme="breadcrumbcss" />
    <section  class="navbarsection">
      <main>
        <div class="videosection">
            <Transition class="transition thing">
              <video-background 
                playbackRate=0.2
                :src="src"
                :poster="poster"
        
                overlay="linear-gradient(to bottom, #003, transparent)" 
                :class="`thing playercss`"
                :style="`height: 605px;`" v-show="pvisvideo === true">
              </video-background>
            </Transition>
            <div id="panorama" class="thing  gradient" v-show="pvisvideo === false">
            </div>
        </div>
        
        <div class="txtdata">
          <h1 class="rainbow-text" v-html="imagetext" :class="formatvhtml"></h1>
        </div>
      </main>
    </section>


  <section>
    <div class="topcomp">
      <DataleftCardright :aboutgovern="aboutgovern" dataleftdivtheme="dataleftdivclass" rightdivtheme="rightdivclass"/>
    </div>
  </section>


    <div>
      <ThreecardsSection  :allcardsdata="contdata" />
    </div>



    <div>
      <AllSlides :displayedPhotos="displayedPhotos" :ophotos="ophotos" :page="page" :perPage="perPage" :pages="pages" :totalPages="totalPages"  />
    </div>



    <div>
      <AlGoals :getagoals="agoals" :getgoaldetails="getgldesc" :firstgoal="firstgoal" :firstgoalid="firstgoalid"
      :imagepath="myPicUrl" agoalstheme="agoalscss" @click.prevent="getgoalId($event)" :catnum="catnum" />
    </div>


    <div class="rptpresent">  
      <AllReports :lastrecordsreportpresent="lastrecordsreportpresent" :reportpresentation="reportpresentation" 
      :openpdf="openpdf" :singlereporttitle="singlereporttitle" :rptfulltext="rptfulltext" 
      :rpcoverpageimagepath="rpcoverpageimagepath" :rplinkname="rplinkname" :bgimage="bgimage" :showbg="showbg"/>
    </div>

<FooterPage />
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import FooterPage from '@/components/FooterPage.vue';
import AlGoals from '@/components/AlGoals.vue';
import DataleftCardright from '@/components/DataleftCardright.vue';
import ThreecardsSection from '@/components/ThreecardsSection.vue';
import AllSlides from '@/components/AllSlides.vue';
import AllReports from '@/components/AllReports.vue';
require('@/assets/css/pannellium-2.5.css');
require('@/assets/css/video-js.css');
import axios from 'axios';
require('@/globalDeclare.js');


export default {
  name: 'AboutView',
  components: {
  NavBar, FooterPage, AlGoals, DataleftCardright, ThreecardsSection, AllSlides, AllReports
},
data() {
  return {
  videoimage: [],
  imagetext: '',
  src: '',
  playrate: '',
  poster: '',
  pvwebm: '',
  pvmp4: '',
  pvstyle: '',
  pvsrc: '',
  pvisvideo: false,
  pvpanorama1: '',
  pvpanorama2: '',
  pvpanorama3: '',
  pvhotspot1: '',
  pvhotspot2: '',
  pvhotspot3: '',
  showVideo: false,
  showPanorama: false,

  myPicUrl: '',
  agoals: [],
  getgldesc: '',
  firstgoal: '',
  firstgoalid: '',

  aboutgovern: '',

  reportpresentation: [],
  reportcnt: '',
  lastrecordsreportpresent: [],
  rppdfpath: '',
  rptitle: '',
  rpdate: '',
  rplinkname: '',
  rptfulltext: '',
  rpcoverpageimagepath: '',
  singlereporttitle: '',
  rplinkname: '',
  rpdate: '',
  showbg: true,
  bgimage: '',
  
  carouselSlides: [],
  catnum: 2,
  


  //pagination props
  ophotos: [],
  page: 1,
  perPage: 1,
  pages: [],
  totalPages: 0,
  displayedPhotos: [],


  openpdf: '',
  openlistreport: '',
  getdtsInfo: '',
  getfirstid: '',
  allcodesingle: ''
  }
},
methods: {
 async getgoalId(event){
  let goalid = parseInt(event.target.value)
  await axios.get(`getagoalid/${goalid}`).then(
  response => { 
  this.getgldesc = response.data[0].gdesc
  this.firstgoalid = response.data[0].gcid
  })
  .catch((error) => {
      console.log(error)
    })
 },
 async getPhotos() {
        await axios.get('homepageotheruploadlisting/sustainoverview').then(
             response => {
              this.ophotos = response.data;
              this.totalPages = response.data.length;
            })
            .catch(response => {
                console.log(response);
            });
        },
},

created() {
  this.getPhotos();
},

async mounted() {
  this.myPicUrl = myUrlPath
await axios.get('allpagespv/sustainoverview').then(
    response => {
      this.videoimage = response.data
      
      this.imagetext = this.videoimage.pvdisplaytext 
      this.src = this.videoimage.pvsrc
      this.playrate = this.videoimage.playbackrate
      this.poster = this.videoimage.pvposter
      // this.pvsrc = this.videoimage.pvsrc
      // this.pvmp4 = this.videoimage.pvmp4
      this.pvstyle = this.videoimage.pvstyle
      this.pvisvideo = this.videoimage.pvisvideo
      this.pvpanorama1 = this.videoimage.pvpanorama1
      this.pvpanorama2 = this.videoimage.pvpanorama2
      this.pvpanorama3 = this.videoimage.pvpanorama3
      this.pvhotspot1 = this.videoimage.pvhotspot1
      this.pvhotspot2 = this.videoimage.pvhotspot2
      this.pvhotspot3 = this.videoimage.pvhotspot3

      // let pvisvideo1 = this.videoimage.pvisvideo
      // this.pvisvideo = pvisvideo1


      if (this.pvisvideo === 'true') {
        this.src = this.videoimage.pvmp4
        this.showVideo
        if (response.status === 403 ) {
        e = "No data available"
        const toast = useToast();
        toast.success(e, {
        timeout: 6000
        });
        }
        else if (response.status === 404) {
          e = "Page Not Found!"
          const toast = useToast();
          toast.success(e, {
          timeout: 6000
        });
        }
      }
      else{
          const config = {
          autoLoad: true,
          scenchange: true,
          compass: false,
          northOffset: -237.5,
          default: {
              firstScene: "hotspotoffice",
              sceneFadeDuration: 1000,
              autoRotate: -.6,
              setTimeout: 100,
              preview: this.poster
              
          },
          scenes: {
              hotspotoffice: {
                  hfov: 180,
                  pitch: 0,
                  yaw: 0,
                  type: "equirectangular",
                  panorama: this.pvpanorama1,
                  hotSpots: [
                      {
                          pitch: 4,
                          yaw: 21.8,
                          type: "scene",
                          sceneId: "anotherhotspot",
                          text: this.pvhotspot1,
                      }
                  ]
              },
              anotherhotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama2,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "lasthotspot",
                            text: this.pvhotspot2,
                        }
                    ]
                },
                lasthotspot: {
                    hfov: 180,
                    pitch: 0,
                    yaw: 90,
                    type: "equirectangular",
                    panorama: this.pvpanorama3,
                    hotSpots: [
                        {
                            pitch: 8,
                            yaw: -58,
                            type: "scene",
                            sceneId: "hotspotoffice",
                            text: this.pvhotspot3,
                        }
                    ]
                },
              
            }
        };
        pannellum.viewer('panorama', config);
      }
  })
  .catch((error) => {
        console.log(error)
      })


  //------------Container Section---------------
  axios.get('getallcardsectionsdata/sustainoverview').then(
    response => {
        this.contdata = response.data
    })
  .catch((error) => {
      console.log(error)
    })
  //------------corpgovernance info---------------
  await axios.get('getcorpgovernanceinfo/').then(
    response => {
        this.aboutgovern = response.data
        this.chartermandate = response.data.chartermandate
        this.policyguideline = response.data.policyguideline
        this.compliantsprocess = response.data.compliantsprocess
        this.cpimg = response.data.cpimg
  })
  .catch((error) => {
      console.log(error)
    })

  //------------All SDGS list---------------
  await axios.get('getsinglegoalslist/').then(
  response => { 
  // this.opdownloaddesc = response.data.opdownloaddesc
  this.agoals = response.data
  })
  .catch((error) => {
      console.log(error)
    }) 

  //------------All SDGS list---------------
  await axios.get('getsinglegoalslist/').then(
  response => { 
  this.firstgoal = response.data[0].gdesc
  })
  .catch((error) => {
      console.log(error)
    }) 

  //------------Get Reports---------------
  await axios.get('reportpresentationlisting/sustainoverview').then(
    response => {
      this.reportpresentation = response.data
      var reportcnt = parseInt(response.data[0].rpid)       

      axios.get(`reportpresentationsinglelisting/${reportcnt}`).then(
      response => {
        this.lastrecordsreportpresent = response.data
        this.rppdfpath = response.data.rppdfpath
        this.rptitle = response.data.rptitle
        this.rpdate = response.data.rpdate
        this.rplinkname = response.data.rplinkname
        this.rptfulltext = response.data.rptfulltext
        this.bgimage = response.data.bgimage
        this.rpcoverpageimagepath = response.data.rpcoverpageimagepath
        this.singlereporttitle = response.data.singlereporttitle
        this.rplinkname = response.data.rplinkname
        this.rpdate = response.data.rpdate
        console.log(this.bgimage)
      })
      .catch((error) => {
        console.log(error)
      })
            
    })
  .catch((error) => {
    console.log(error)
  })


  },

}
</script>

<style scoped>
.section03 {
  height: 300px;
}
.container {
  display: grid;
  height: 100vh;
  grid-template-columns: 1fr;
  grid-template-rows: .2fr 1.2fr .2fr;
  grid-template-areas: 
  "nav nav nav" 
  "main main main" 
  "footer footer footer";
  grid-gap: 0.2rem;
  font-family: "Inter", sans-serif;
  font-size: 800;
  font-size: 12px;
  color: #234234;
  text-align: center;
}

html { 
  height: 100%;
  margin:0px;
  background: url('../assets/slide-5.jpg') no-repeat center center;
  background-size: cover;
  background-attachment: fixed;
}

main {
  background: white;
  grid-area: main;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
  border-radius: 0px;
  margin-top:-5px;
}

 .sec01 {
  margin-top: 400px;
  padding-left: 100px;
  padding-right: 100px;
 }
.reportpresentcss {
  margin-top: -100px;
}
.rptpresent {
  margin-bottom: 200px;
}
/* Move the background and make it larger. 
/* Media Query CSS*/
@media only screen and (max-width: 600px) {
  .txtdata {
    margin-bottom: 100px;
    width: 400px;
    padding-right: 10px;
  }
  .topcomp {
    margin-top: 250px;
    padding-left: -20px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .txtdata {
    margin-bottom: 200px;
    width: 600px;
    padding-right: 10px;
  }
  .topcomp {
    margin-top: 250px;
    padding-left: -20px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .txtdata {
    margin-bottom: 30px;
    width: 900px;
    padding-right: 10px;
  }
 }

 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .txtdata {
    margin-bottom: 100px;
    width: 900px;
    padding-right: 10px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1400px) {

}

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1600px) {

}
</style>
